import DadosIniciais from '../ModulosCrefito/DadosIniciais'
import DadosEstabelecimento from '../ModulosCrefito/DadosEstabelecimento'
import Dificuldades from '../ModulosCrefito/Dificuldades'
import Consultorio from './TiposFisio/Consultorio'
import Livre from './TiposFisio/Livre'
import Caps from './TiposFisio/Caps'
import Clinica from './TiposFisio/Clinica'
import Nasf from './TiposFisio/Nasf'
import ExercicioIlegal from './TiposFisio/ExercicioIlegal'
import RedeSocial from './TiposFisio/RedeSocial'
import Ilpis from './TiposFisio/Ilpis'
import Hospital from './TiposFisio/Hospital'
import Fechado from './Fechado'
import AiContainer from '../AIs/AisFisio/AiContainer'
import React from 'react'

import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'
import { tipoTv, dadosIniciais, dadosEstabelecimento, recuperar } from '../../../state/slices/formSlice'
import { useState, useEffect } from 'react'

const TermoDeVisita = () => {
    const qtd = useSelector((state) => state.addForm.qtdModulos)
    const ficha = useSelector((state) => state.addForm.modulos)
    const [tipo, setTipo] = useState({})
    const dispatch = useDispatch()
    const id = window.location.pathname.slice(7)
    useEffect(() => {
        const url = `/api/tvs/processo/${id}`
        axios(url)
            .then(res => {
                let paf = res.data
                dispatch(dadosIniciais({ "name": "cpfCnpj", "value": paf.cpfCnpj }))
                dispatch(dadosIniciais({ "name": "processo", "value": paf.numero }))
                dispatch(dadosEstabelecimento({
                    estabelecimento: paf.estabelecimento || null, fantasia: paf.fantasia || null,
                    registro: paf.registro || null, horarioAtendimento: paf.horarioAtendimento || null,
                    endereco: paf.endereco || null, municipio: paf.municipio || null, uf: paf.uf || null,
                    cep: paf.cep || null, telefone: paf.telefone || null, email: paf.email || null
                }))
            })
            .catch(error => {
                alert(error)
            })
    }, [])

    const enviar = () => {
        const url = `/api/tvs/tvfisio/${id}`
        axios.post(url, { qtd, ficha, funcionario: localStorage.nome })
            .then(res => {
                alert(res.data)
                window.location = `/documentosPaf/${id}`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    const escolha = (e) => {
        setTipo(e.target.value)
        dispatch(tipoTv({ e }))
    }

    const recuperarDados = () => {
        dispatch(recuperar(localStorage.safeData))
    }

    return (
        <>
            <div style={{ textAlign: "left", width: "50vw", margin: "auto", marginBottom: "4vh" }}>
                <div style={{
                    marginTop: "3vh",
                    textAlign: "left", color: "#484848"
                }}>
                    <div><b>Termo de Visita</b></div>
                    <select style={{
                        width: "12vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                        borderRadius: "5px", minHeight: "5px"
                    }}
                        onChange={e => escolha(e)} >
                        <option value=""></option>
                        <option value="Consultorio">Consultório</option>
                        <option value="Caps">Caps</option>
                        <option value="Clínica">Clínica</option>
                        <option value="Nasf">Nasf</option>
                        <option value="Exercício Ilegal">Exercício Ilegal</option>
                        <option value="Rede Social">Rede Social</option>
                        <option value="Ilpis">Ilpis</option>
                        <option value="Hospital">Hospital</option>
                        <option value="Livre">Livre</option>
                        <option value="Fechado/Desativado">Fechado/Desativado</option>
                    </select>
                </div>
            </div>
            <DadosIniciais modulo="dadosIniciais" />
            <DadosEstabelecimento modulo="dadosEstabelecimento" />
            {RenderFicha()}
            <AiContainer />
            <Dificuldades modulo="dificuldades" />
            {/* <div>
                <button className='btn btn-warning mt-2' style={{color: "#FFFF"}} onClick={e => recuperarDados()}>Recuperar Dados</button>
            </div> */}
            <button className='btn btn-success mt-2' onClick={e => enviar()}>Enviar</button>
        </>
    )

    function RenderFicha() {
        if (tipo === "Consultorio") return <Consultorio />
        else if (tipo === "Livre") return <Livre />
        else if (tipo === "Caps") return <Caps />
        else if (tipo === "Clínica") return <Clinica />
        else if (tipo === "Nasf") return <Nasf />
        else if (tipo === "Exercício Ilegal") return <ExercicioIlegal />
        else if (tipo === "Rede Social") return <RedeSocial />
        else if (tipo === "Ilpis") return <Ilpis />
        else if (tipo === "Hospital") return <Hospital />
        else if (tipo === "Fechado/Desativado") return <Fechado />
    }
}

export default TermoDeVisita